import dynamicImage from './dynamicImage';

export default {
  dynamicImage
};
